module.exports = __webpack_public_path__ + "img/buyers_expressed interest cropped.1b580fc1.svg";